import { CommonModule } from '@angular/common'
import { Component, inject } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { RouterModule } from '@angular/router'
import { NgIconComponent, provideIcons } from '@ng-icons/core'
import {
    lucideMail,
    lucideArrowLeft,
    lucideArrowRight,
    lucideCheckCircle2,
    lucideSparkles,
    lucideShieldCheck,
    lucideKeyRound,
    lucideRefreshCw,
    lucideAlertCircle,
} from '@ng-icons/lucide'
import { ForgotPasswordFormService } from '../../services/forgot-password-form.service'

@Component({
    selector: 'lib-page-forgot-password',
    imports: [CommonModule, ReactiveFormsModule, RouterModule, NgIconComponent],
    providers: [
        ForgotPasswordFormService,
        provideIcons({
            lucideMail,
            lucideArrowLeft,
            lucideArrowRight,
            lucideCheckCircle2,
            lucideSparkles,
            lucideShieldCheck,
            lucideKeyRound,
            lucideRefreshCw,
            lucideAlertCircle,
        }),
    ],
    templateUrl: './page-forgot-password.component.html',
    styleUrls: ['./page-forgot-password.component.css'],
})
export class PageForgotPasswordComponent {
    public forgotPasswordFormService = inject(ForgotPasswordFormService)

    onSubmit() {
        this.forgotPasswordFormService.submit()
    }

    resend() {
        this.forgotPasswordFormService.submitted.set(false)
        this.onSubmit()
    }

    resetForm() {
        this.forgotPasswordFormService.submitted.set(false)
        this.forgotPasswordFormService.form.reset()
    }
}
